import { Link } from 'react-router-dom';
import { useConsent } from '../ConsentContext';

const CookieConsent = () => {
  const { consent, setConsent } = useConsent();
  if (consent) return null;

  return (
    <div id="cookie-bar" className="d-flex justify-content-between">
      <div className="d-flex align-items-center">
        <div>
          We use cookies to improve your experience and analyze site traffic. By continuing to use our site, you consent
          to our use of cookies. You can decline of the use of cookies for analytics and tracking purposes. We do not
          sell your personal information.{' '}
          <span>
            Please review our{' '}
            <Link className="underline" to={'/privacy-policy/'}>
              Privacy Policy
            </Link>
            .
          </span>
        </div>
        <div className="d-flex align-items-center ms-3">
          <Link className="btn-theme" onClick={() => setConsent('accept')} to={'#'}>
            Accept
          </Link>
          <Link className="btn-theme ms-2" onClick={() => setConsent('decline')} to={'#'}>
            Decline
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
